<template>
    <div class="apple_create">
        <div class="apple_create_header" :style="{width: fixWidth}">
            <el-button type="text" icon="el-icon-back" :style="{fontSize: '14px'}" @click="handleClickBack">取消</el-button>
            <span class="text" :style="{padding: '0 10px', fontSize: '14px'}">|</span>
            <span class="text" :style="{padding: '0 10px 0 0', fontSize: '14px'}">{{title}}</span>
            <div v-if="type == 'create_org'">
                <el-button type="primary" size="mini" @click="handleSave" :loading="org_result.loading">创建并关闭</el-button>
                <el-button type="success" size="mini" @click="handleSaveToGroup" :loading="group_result.loading">创建并新建广告组</el-button>
            </div>
            <div v-if="type == 'create_group'">
                <el-button type="primary" size="mini" @click="handleSaveAdsGroup" :loading="org_result.loading">创建</el-button>
            </div>
            <div v-if="type == 'edit_org'">
                <el-button type="primary" size="mini" @click="handleSaveEditOrg" :loading="org_result.loading">保存</el-button>
            </div>
            <div v-if="type == 'edit_group'">
                <el-button type="primary" size="mini" @click="handleSaveAdsGroupEditGroup" :loading="group_result.loading">保存</el-button>
            </div>
        </div>
        <div class="apple_create_body" id="apple_create_body">
            <h2 :style="{padding: '10px 0 0 10px'}" v-if="type=='create_org'||type=='create_group'">广告系列</h2>
            <div class="tabs" v-if="type=='create_org'||type=='create_group'">
                <div class="tabs_name">
                    <div
                    v-for="(tab, index) in tabs"
                    :key="index"
                    class="tab_hover"
                    :class="{ 'tab': true, 'active': activeTab === index }"
                    @click="activateTab(index)"
                    >
                    {{ tab.name }}
                    </div>
                    </div>
                <div
                class="indicator"
                :style="{ width: indicatorWidth + 'px', transform: 'translateX(' + indicatorOffset + 'px)' }"
                ></div>
            </div>
            <Ad_org v-if="activeTab == 0" 
            ref="ad_org" 
            @postresult="handleOrgpResult" 
            @postOrg="handleOrgList"
            :org="org_list"></Ad_org>
            <Ad_group 
            v-if="activeTab == 1" 
            ref="ad_group" 
            @postresult="handleGroupResult" 
            @postOrg="handleOrgList"
            :org="org_list" 
            :campaign="campaign_list"></Ad_group>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';
    import Ad_org from "./ad_org.vue";
    import Ad_group from "./ad_group.vue";
    export default {
        name: 'create_apple',
        components:{
            Ad_org,
            Ad_group
        },
        props:{
        },
        data() {
            return {
                type: 'create', // 创建 create  编辑 edit_org  edit_group
                tabs: [
                    { name: '新建广告系列' },
                    { name: '已有广告系列' },
                ],
                activeTab: 0,  // 0 新建广告系列   1已有广告系列
                indicatorWidth: 0,
                indicatorOffset: 0,
                // type: 'create',    // 创建 create  编辑 edit
                org_result: {
                    loading: false, 
                    dialog: false, 
                    success: false,
                },
                group_result:{
                    loading: false, 
                    dialog: false, 
                    success: false,
                },
                list: [
                    'org_add_ad',    // 广告系列组新建广告
                    'campaign_add_ad',     // 广告系列新建广告
                    'campaign_add_campaign',     // 广告系列新建广告系列
                    'adgroup_add_ad',     // 广告组新建广告
                    'adgroup_add_adgroup',   // 广告组新建广告组
                    'keyword_add_ad',    // 关键词新建广告
                    'search_term_add_ad',     // 搜素词新建广告
                    'negative_keyword_add_ad',     // 否定关键词新建广告
                ],
                org_list: {
                    id: '',
                    list: []
                },
                campaign_list: {
                    type: '',
                    list: []
                },
                fixWidth: '1000px',
            }
        },
        computed:{
            ...mapGetters(['submit_url_name', 'apple_create_type']),
            title(){
                let titleMap = {
                    create_org:'新建广告',
                    create_group:'新建广告组',
                    edit_org:'编辑广告系列',
                    edit_group:'编辑广告组',
                };
                return titleMap[this.type]||'新建广告';
            },
        },
        watch:{
        },
        mounted() {
            let apple_create_body = document.getElementById('apple_create_body')
            this.fixWidth = `${apple_create_body.clientWidth}px`
            if(this.apple_create_type == 'createOrg' || this.apple_create_type == 'editOrg') {
                if(this.apple_create_type == 'editOrg') {
                    this.type = 'edit_org'
                }else{
                    this.type = 'create_org'
                }
                this.activateTab(0);
            }else if(this.apple_create_type == 'createGroup' || this.apple_create_type == 'editGroup') {
                if(this.apple_create_type == 'editGroup') {
                    this.type = 'edit_group'
                }else{
                    this.type = 'create_group'
                }
                this.activateTab(1);
            }   
        },
        methods: {
            //保存并关闭
            handleSave(params) {

                this.$refs.ad_org.handleSubmit(this.submit_url_name, 'createOrg');
                // this.$emit('adsClose',{id:1, name: '创建并关闭'})
            },
            handleSaveToGroup(){
                this.$refs.ad_org.handleSubmit(this.submit_url_name, 'createOrg','toGroup');
            },
            //保存创建广告组
            handleSaveAdsGroup(params) {
                // this.$store.commit('apple/SET_CREATE_TYPE','createOrg');
                console.log(this.submit_url_name)
                this.$refs.ad_group.handleSubmit(this.submit_url_name, 'createGroup')
                // this.$emit('adsClose',{id:1, name: '创建并新建广告组'})
            },
            // 编辑广告系列
            handleSaveEditOrg() {
                // 'editOrg'
                this.$refs.ad_org.handleSubmit(this.submit_url_name, 'editOrg');
            },
            // 编辑广告组
            handleSaveAdsGroupEditGroup() {
                this.$refs.ad_group.handleSubmit(this.submit_url_name, 'editGroup')
            },
            // 共享 org_list
            handleOrgList(params) {
                this.org_list = params;
            },
            // 广告系列结果
            handleOrgpResult(params) {
                console.log('handleOrgpResult',params);
                // {loading: true, dialog: false, success: false}
                this.org_result = params
                // this.org_list = params['org_list'];
                if(params.type == 'editOrg') {
                    this.$store.commit('apple/SET_CREATE_TYPE','editOrg');
                }else if(params.type == 'createOrg') {
                    this.$store.commit('apple/SET_CREATE_TYPE','createOrg');
                }
                if(params.success) {
                    if(params.type == 'editOrg') {
                        this.$store.commit('apple/SET_CREATE_TYPE','editOrg');
                        this.$store.commit('apple/IS_RELOAD_LIST');
                        this.$emit('adsClose',{id:2, name: 'editOrg'});
                    }else if(params.type == 'createOrg') {
                        console.log('params.toGroup', params.toGroup)
                        if(params.toGroup){
                            this.type = 'create_group';
                            let campList =  params['campaign_list'];
                            this.campaign_list.list = campList? campList.list||[]: [];

                            this.activateTab(1);
                        }else{
                            this.$store.commit('apple/SET_CREATE_TYPE','createOrg');
                            this.$emit('adsClose',{id:1, name: 'createOrg'})
                        }
                    }
                    
                }
                
            },
            // 广告组结果
            handleGroupResult(params) {
                // {loading: true, dialog: false, success: false, type: ''}
                this.group_result = params
                // this.org_list = params['org_list']
                
                if(params.type == 'editGroup') {
                    this.$store.commit('apple/SET_CREATE_TYPE','editGroup');
                }else if(params.type == 'createGroup') {
                    this.$store.commit('apple/SET_CREATE_TYPE','createGroup');
                }
                if(params.success) {
                    if(params.type == 'editGroup') {
                        this.$store.commit('apple/SET_CREATE_TYPE','editGroup');
                        this.$store.commit('apple/IS_RELOAD_LIST');
                        this.$emit('adsClose',{id:1, name: 'editGroup'})
                    }else if(params.type == 'createGroup') {
                        this.$store.commit('apple/SET_CREATE_TYPE','createGroup');
                        this.$emit('adsClose',{id:1, name: 'createGroup'})
                    }
                }
                
            },
            // 切换
            activateTab(index) {
                console.log(index)
                if(index == 0) {
                    if(this.group_result.dialog) {
                        this.$confirm('切换后，已填写的内容将会被清空?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            this.activeTab = 0;
                            this.type = 'create_org';
                            this.org_result.dialog = false;
                            this.$nextTick(()=>{
                                // 获取选中的选项卡元素
                                const selectedTab = this.$el.querySelectorAll('.tab')[0];
                                if(!selectedTab) return;
                                // 设置指示器的宽度和位置
                                this.indicatorWidth = selectedTab.offsetWidth;
                                this.indicatorOffset = selectedTab.offsetLeft;
                            })

                        }).catch(() => {
                            this.activeTab = 1;
                            this.type = 'create_group';
                            this.$nextTick(()=>{
                                // 获取选中的选项卡元素
                                const selectedTab = this.$el.querySelectorAll('.tab')[1];
                                if(!selectedTab) return;
                                // 设置指示器的宽度和位置
                                this.indicatorWidth = selectedTab.offsetWidth;
                                this.indicatorOffset = selectedTab.offsetLeft;
                            })
                        });
                    }else{
                        this.activeTab = index;
                        if(this.apple_create_type=='createGroup'||this.apple_create_type=='createOrg'){
                            this.type = index==1?'create_group':'create_org';
                        }
                        this.org_result.dialog = false;

                        this.$nextTick(()=>{
                            // 获取选中的选项卡元素
                            const selectedTab = this.$el.querySelectorAll('.tab')[index];
                            if(!selectedTab) return;
                            // 设置指示器的宽度和位置
                            this.indicatorWidth = selectedTab.offsetWidth;
                            this.indicatorOffset = selectedTab.offsetLeft;
                        })
                    }

                    
                    
                }else if(index == 1) {
                    if(this.org_result.dialog) {
                        this.$confirm('切换后，已填写的内容将会被清空?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            this.activeTab = 1;
                            this.type = 'create_group';
                            this.$nextTick(()=>{
                                // 获取选中的选项卡元素
                                const selectedTab = this.$el.querySelectorAll('.tab')[1];
                                if(!selectedTab) return;
                                // 设置指示器的宽度和位置
                                this.indicatorWidth = selectedTab.offsetWidth;
                                this.indicatorOffset = selectedTab.offsetLeft;
                            })
                        }).catch(() => {
                            this.activeTab = 0;
                            this.type = 'create_org';
                            this.$nextTick(()=>{
                                // 获取选中的选项卡元素
                                const selectedTab = this.$el.querySelectorAll('.tab')[0];
                                if(!selectedTab) return;
                                // 设置指示器的宽度和位置
                                this.indicatorWidth = selectedTab.offsetWidth;
                                this.indicatorOffset = selectedTab.offsetLeft;
                            })
                        });
                    }else{
                        this.activeTab = index;
                        if(this.apple_create_type=='createGroup'||this.apple_create_type=='createOrg'){
                            this.type = index==1?'create_group':'create_org';
                        }
                        this.$nextTick(()=>{
                            // 获取选中的选项卡元素
                            const selectedTab = this.$el.querySelectorAll('.tab')[index];
                            if(!selectedTab) return;
                            // 设置指示器的宽度和位置
                            this.indicatorWidth = selectedTab.offsetWidth;
                            this.indicatorOffset = selectedTab.offsetLeft;
                        })
                    }
                    this.org_result.dialog = false;

                    
                }
                
            },
            handleClickBack() {
                this.$emit('adsClose',{id:1, name: '创建并新建广告组'})
            },
            editCampaign(data){
                console.log('editCampaign',data);
                this.type = 'edit_org';
                this.$nextTick(()=>{
                    this.$refs.ad_org.getEditInfo(data);
                })
            },
            createCampaign(){
                console.log('createCampaign');
                this.type = 'create';
                this.activeTab = 0;
                this.$nextTick(()=>{

                })
            },
        }

    }
    
</script>
<style lang="scss" scoped>
.apple_create{
    position: relative;
    padding: 10px 20px;
    // display: flex;
    // flex-direction: column;
    &:before{
        content: '';
        position: fixed;
        display: block;
        left: 0;
        right: 0;
        width: 100%;
        height: 10px;
        background-color: #f1f4f9;
        z-index: 2;
        top: 50px;
    }
}
.apple_create_header{
    background-color: #fff;
    padding: 4px 8px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    position: fixed;
    top: 52px;
    z-index: 2;
    box-shadow: 0px 1px 2px #d9d9d9;
    .text {
        display:inline-block;
        line-height: 32px;
    }
}
.apple_create_body{
    margin-top: 52px;
    background-color: #fff;
    .tabs {
        position: relative;
        /* 蓝色横条动画效果 */
        .indicator {
            height: 2px;
            background-color: #409EFF;
            margin-top: -1px;
            transition: width 0.3s ease, transform 0.3s ease; /* 添加过渡效果 */
        }
    }
    .tabs_name {
        display: flex;
        border-bottom: 1px solid #eaeaea;
    }

    .tab_hover {
        padding: 10px 20px;
        cursor: pointer;
        border: 1px solid transparent;
        font-size: 14px;
    }

    .tab_hover:hover {
        // background-color: #f0f0f0;
    }

    
}
</style>
